import {
    useDeleteIdsHealthcareservicesHcsIdContactsContactId,
    usePostIdsHealthcareservicesHcsIdContacts,
} from '@toktokdoctech/tokapi-client'
import { searchPhysician } from '../utils/physicians'
import { capitalizeFirstLetter } from '../utils/stringUtils'
import { AddAnnContactParams, DeleteAnnContactParams } from './_props'

const useAnnContactUtils = () => {
    const { mutateAsync: deleteContactMutation, isPending: isDeletingContact } =
        useDeleteIdsHealthcareservicesHcsIdContactsContactId()
    const { mutateAsync: createContactMutation, isPending: isAddingContact } =
        usePostIdsHealthcareservicesHcsIdContacts()

    const addAnnContact = async ({ hcsId, rpps }: AddAnnContactParams) => {
        const physician = await searchPhysician(rpps)

        if (!physician) {
            return // do nothing
        }

        await createContactMutation({
            hcsId,
            data: {
                rpps,
                nationalId: Number(physician[0]?.userIdnps),
                firstName: capitalizeFirstLetter(physician[0]?.prenomdexercice),
                lastName: physician[0]?.nomdexercice.toUpperCase(),
                codeProfession: physician[0]?.codeprofession,
                speciality: physician[0]?.libellesavoirfaire,
            },
        })
    }

    const deleteAnnContact = async ({ hcsId, contactId }: DeleteAnnContactParams) => {
        let resolvedContactId = contactId

        if (resolvedContactId) {
            await deleteContactMutation({ hcsId, contactId: resolvedContactId })
        }
    }

    return {
        addAnnContact,
        deleteAnnContact,
        isAddingContact,
        isDeletingContact,
    }
}

export default useAnnContactUtils
